module.exports = __webpack_public_path__ + "img/insurance-piggy.f9787a9.png";